// Cor do badge por prefixo do tipo (auth.*, cotacao.*, etc) — tokens Íris +
// sky/violet literais (com 20 categorias e poucas cores, há reuso intencional).
export function corPorPrefixo(tipo: string): string {
  const prefixo = tipo.split('.')[0];
  switch (prefixo) {
    case 'auth':
      return 'bg-accent-soft text-accent-text';
    case 'usuario':
    case 'papel':
    case 'log':
      return 'bg-danger-soft text-danger';
    case 'cotacao':
      return 'bg-warning-soft text-warning';
    case 'pedido':
      return 'bg-ok-soft text-ok';
    case 'sugestao':
    case 'meta':
    case 'meta_dim':
    case 'estatistica':
      return 'bg-sky-500/15 text-sky-600 dark:text-sky-300';
    case 'reposicao':
    case 'cte':
      return 'bg-ok-soft text-ok';
    case 'conferencia':
      return 'bg-teal-500/15 text-teal-600 dark:text-teal-300';
    case 'agrupamento':
      return 'bg-warning-soft text-warning';
    case 'marca_gestao':
    case 'fornecedor_gestao':
      return 'bg-violet-500/15 text-violet-600 dark:text-violet-300';
    case 'organizacao':
    case 'catalogo_digital':
    case 'catalogo':
    case 'parametros':
    case 'cloudflare':
      return 'bg-accent-soft text-accent-text';
    default:
      return 'bg-surface-2 text-tx-2';
  }
}

/**
 * Converte o payload de auditoria na lista de campos alterados, quando ele é um
 * diff do `AuditDiff` (`{diff: {campo: {de, para}}}`). Devolve `null` pra payload
 * que não é diff — o diálogo cai no JSON cru, que continua disponível.
 */
export function extrairDiff(dados: string): Array<{ campo: string; de: unknown; para: unknown }> | null {
  try {
    const obj = JSON.parse(dados);
    const diff = obj?.diff;
    if (!diff || typeof diff !== 'object') return null;
    const linhas = Object.entries(diff)
      .filter(([, v]) => v && typeof v === 'object' && 'de' in (v as object) && 'para' in (v as object))
      .map(([campo, v]) => ({ campo, de: (v as never)['de'], para: (v as never)['para'] }));
    return linhas.length > 0 ? linhas : null;
  } catch {
    return null;
  }
}
